import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({
  children,
  page,
  allowedPages = [],
  accessReady = true,
  fallbackPath = "/source-data",
}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (!accessReady) {
    return null;
  }
  if (page && !allowedPages.includes(page)) {
    return <Navigate to={fallbackPath} replace />;
  }
  return children;
};

export default ProtectedRoute;
